<template>
  <div class="v-status-toggler" @click="toggle">
    <slot :flag="flag"></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
      flag: this.trueOnInit
    }
  },
  methods: {
    toggle () {
      this.changeFlag.bind(this)()
    }
  },
  props: {
    trueOnInit: {
      default: 1,
      type: Number
    },
    changeFlag: {
      default() { this.flag = !!this.flag },
      type: Function
    }
  }
}
</script>
